<template>
  <div class="box-steps">
    <div class="steps-title">
      <span
        v-for="step in maxSteps"
        :key="step.id" class="step"
        :class="{ active: $store.getters.getCurrentStep + 1 === step }">
          {{ step }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserProfileSteps',
  data () {
    return {
      maxSteps: 9
    }
  }
}
</script>

<style lang="scss" scoped>

$grey: #ccc;

.box-steps {

  .steps-title {
    margin: 3rem 0 4rem;
    text-align: center;

    .step {
      $s: 4.5rem;

      position: relative;
      display: inline-block;
      margin: 0 1.25rem;
      width: $s;
      height: $s;
      line-height: $s;
      font-size: 2.3rem;
      font-weight: 300;
      border: .2rem solid $grey;
      color: $grey;
      background-color: $white;
      border-radius: 50%;

      &:not(:nth-of-type(1)):before {
        $s: 2.65rem;

        content: '';
        position: absolute;
        top: 50%;
        left: -$s;
        width: $s;
        height: 3px;
        background-color: $grey;
      }

      &.active {
        background-color: $green;
        color: $white;
        border-color: $green;
        transition: .3s;

        &:before {
          background-color: $green;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/userProfile/UserProfileSteps.vue